<template>
  <div class="hw-nav-root">
    <header class="hw-nav" :class="{ 'is-scrolled': scrolled, 'is-open': menuOpen }">
      <div class="hw-nav-inner">
        <a class="hw-brand" href="javascript:void(0)" @click="go('#home')">
          <span class="hw-logo">
            <img src="@/assets/img/logo.png" alt="Hardwired" />
          </span>
          <span class="hw-brand-text">
            <strong>HARDWIRED</strong>
            <span>Digital Solutions</span>
          </span>
        </a>

        <nav class="hw-nav-links">
          <button class="hw-nav-link" @click="go('#home')">Início</button>
          <button class="hw-nav-link" @click="go('#services')">Serviços</button>
          <button class="hw-nav-link" @click="go('#about')">Sobre</button>
          <div class="hw-drop" :class="{ 'is-open': dropOpen }" @mouseenter="dropOpen = true" @mouseleave="dropOpen = false">
            <button class="hw-drop-btn" @click="dropOpen = !dropOpen">Produtos</button>
            <div class="hw-drop-menu">
              <a
                class="hw-drop-item"
                href="https://mkgest.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="@/assets/img/mkgest.jpg" alt="MKGest" />
                <span>MKGest</span>
              </a>
            </div>
          </div>
          <button class="hw-nav-link" @click="go('#contact')">Contacto</button>
        </nav>

        <button class="hw-btn hw-btn-primary" @click="go('#contact')">Falar connosco</button>
        <button class="hw-burger" :class="{ 'is-open': menuOpen }" type="button" aria-label="Menu" @click="menuOpen = !menuOpen">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
    <div class="hw-mobile" ref="panel" v-show="menuOpen">
      <button type="button" @click="go('#home')">Início</button>
      <button type="button" @click="go('#services')">Serviços</button>
      <button type="button" @click="go('#about')">Sobre</button>
      <button type="button" @click="go('#mkgest')">MKGest</button>
      <button type="button" @click="go('#contact')">Contacto</button>
      <a href="https://mkgest.com" target="_blank" rel="noopener noreferrer">Abrir MKGest</a>
      <button class="hw-btn hw-btn-primary" type="button" @click="go('#contact')">Falar connosco</button>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    scrolled: false,
    menuOpen: false,
    dropOpen: false,
    scrollY: 0,
  }),
  methods: {
    onScroll() {
      this.scrolled = window.pageYOffset > 12;
    },
    lockScroll() {
      this.scrollY = window.pageYOffset;
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${this.scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
    },
    unlockScroll() {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      window.scrollTo(0, this.scrollY || 0);
    },
    go(hash) {
      this.menuOpen = false;
      const scroll = () => {
        this.$nextTick(() => {
          this.$vuetify.goTo(hash, { offset: 12, duration: 450 });
        });
      };
      if (this.$route.path !== "/") {
        this.$router.push("/").then(scroll);
      } else {
        scroll();
      }
    },
  },
  mounted() {
    this.onScroll();
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.$nextTick(() => {
      if (this.$refs.panel) {
        document.body.appendChild(this.$refs.panel);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    this.unlockScroll();
    if (this.$refs.panel && this.$refs.panel.parentNode) {
      this.$refs.panel.parentNode.removeChild(this.$refs.panel);
    }
  },
  watch: {
    menuOpen(value) {
      if (value) {
        this.lockScroll();
      } else {
        this.unlockScroll();
      }
    },
  },
};
</script>
